type WidgetType = "threeItems" | "oneBigItem" | "multipleDataType";

export const getSliderProps = (widgetType: WidgetType, containerWidth: number) => {
   const baseSliderSettings = {
      infinite: true,
      speed: 500,
      slidesToScroll: 1,
      swipe: true,
      dots: false,
      draggable: true,
   };

   const sliderSettingsMap = {
      threeItems: { slidesToShow: 3 },
      oneBigItem: { slidesToShow: 1 },
      multipleDataType: {
         slidesToShow: containerWidth > 687 ? 3 : containerWidth < 477 ? 1 : 2,
      },
   };

   return {
      ...baseSliderSettings,
      ...(sliderSettingsMap[widgetType] || {}),
   };
};
